import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
import { site } from '../data/site';

const p = (text) => ({ t: 'p', text });
const ul = (...items) => ({ t: 'ul', items });

const sections = [
  {
    title: 'Agreement to These Terms',
    blocks: [
      p(`These Terms of Use govern your access to and use of the website at https://yse-media.com (the "Website"), operated by ${site.company}, trading as ${site.brand} ("we", "us" or "our"), with its registered office at ${site.address}.`),
      p('By accessing or using the Website you agree to be bound by these Terms. If you do not agree, please do not use the Website.'),
    ],
  },
  {
    title: 'Use of the Website',
    blocks: [
      p('You may use the Website for lawful purposes only. You agree not to:'),
      ul(
        'Use the Website in any way that breaches applicable local, national or international law or regulation',
        'Attempt to gain unauthorised access to the Website, the server on which it is stored or any connected system',
        'Transmit any material that is unlawful, harmful, defamatory or contains viruses or other malicious code',
        'Copy, scrape or reproduce content from the Website for commercial purposes without our written permission'
      ),
    ],
  },
  {
    title: 'Intellectual Property',
    blocks: [
      p(`All content on the Website — including text, graphics, logos, images and the overall design — is owned by or licensed to ${site.company} and is protected by copyright, trademark and other intellectual property laws. You may view and print pages for your personal, non-commercial use only.`),
    ],
  },
  {
    title: 'Enquiries and Communications',
    blocks: [
      p('Information you send us through the Website, including via the contact form or by email, is handled in accordance with our Privacy Policy. Submitting an enquiry does not create a client relationship; any services we provide are governed by a separate written agreement.'),
    ],
  },
  {
    title: 'Third-Party Links and Services',
    blocks: [
      p('The Website may contain links to websites or services operated by third parties. These links are provided for your convenience only. We have no control over, and accept no responsibility for, the content, privacy policies or practices of any third-party sites or services.'),
    ],
  },
  {
    title: 'Disclaimer',
    blocks: [
      p('The Website and its content are provided on an "as is" and "as available" basis. While we aim to keep information accurate and up to date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy or availability of the Website.'),
    ],
  },
  {
    title: 'Limitation of Liability',
    blocks: [
      p(`To the fullest extent permitted by law, ${site.company} shall not be liable for any indirect, incidental, special or consequential loss or damage arising out of or in connection with your use of, or inability to use, the Website. Nothing in these Terms excludes liability that cannot be excluded under applicable law.`),
    ],
  },
  {
    title: 'Changes to These Terms',
    blocks: [
      p('We may revise these Terms from time to time. The updated version will be posted on this page with a new "Last updated" date. Your continued use of the Website after changes are posted constitutes your acceptance of them.'),
    ],
  },
  {
    title: 'Governing Law',
    blocks: [
      p('These Terms are governed by the laws of the Republic of Cyprus. Any dispute arising from or relating to them shall be subject to the exclusive jurisdiction of the courts of Cyprus.'),
    ],
  },
  {
    title: 'Contact Us',
    blocks: [
      p('If you have any questions about these Terms, you can contact us:'),
      ul(`By email: ${site.email}`, `By post: ${site.company}, ${site.address}`),
    ],
  },
];

export default function Terms() {
  return <LegalLayout title="Terms of Use" updated="October 2026" sections={sections} />;
}
